import { useMemo, useRef, useState } from 'react'
import { nanoid } from '@reduxjs/toolkit'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { noop } from 'utils'

const CurrencyInput = ({
  id,
  name,
  max,
  min,
  step,
  maxLength,
  value,
  onChange = noop,
  onValueChange = noop,
  disabled = false,
  error,
  placeholder,
  type = '원',
  typeVisible = true,
  className = 'box_inptxt inp_num',
  integer = true,
  children,
  ...rest
}) => {
  const idRef = useRef(id || nanoid())
  const [isEditing, setEditing] = useState(false)
  const formatValue = useMemo(() => {
    const parsed = integer ? Number.parseInt(value, 10) : Number(value)
    return value === '' || isNaN(parsed)
      ? ''
      : parsed.toLocaleString('ko-KR', {
          ...(maxLength && { maximumFractionDigits: maxLength - 1 }),
        })
  }, [integer, maxLength, value])
  const preventKeys = useMemo(
    () => (integer ? ['e', 'E', '+', '-', '.'] : ['e', 'E', '+', '-']),
    [integer]
  )
  const handleChange = event => {
    const { value: inputValue } = event.target
    if (maxLength && inputValue.length > maxLength) {
      return
    }
    onChange(event)
    onValueChange(inputValue)
  }
  return (
    <span
      className={classNames(className, {
        on: isEditing,
        in_active: disabled,
        in_error: error,
      })}>
      {children}
      {typeVisible && <span className="num_byte">{type}</span>}
      <span className="inner_inp">
        {placeholder && formatValue === '' && (
          <label htmlFor={idRef.current} className="lab_txt">
            {placeholder}
          </label>
        )}
        {isEditing ? (
          <input
            type="number"
            onBlur={() => setEditing(false)}
            value={value}
            onKeyDown={e => preventKeys.includes(e.key) && e.preventDefault()}
            onChange={handleChange}
            id={idRef.current}
            name={name}
            className="inp_txt"
            max={max}
            min={min}
            step={step}
            {...rest}
          />
        ) : (
          <input
            type="text"
            onFocus={() => setEditing(true)}
            value={formatValue}
            autoComplete="off"
            readOnly
            id={idRef.current}
            name={name}
            className="inp_txt"
            disabled={disabled}
            {...rest}
          />
        )}
      </span>
    </span>
  )
}

CurrencyInput.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  max: PropTypes.number,
  min: PropTypes.number,
  step: PropTypes.number,
  maxLength: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  onValueChange: PropTypes.func,
  disabled: PropTypes.bool,
  error: PropTypes.any,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  typeVisible: PropTypes.bool,
  className: PropTypes.string,
  integer: PropTypes.bool,
  children: PropTypes.node,
}

export default CurrencyInput
